import React, { useEffect, useRef, useState } from 'react'

import { firewallAPI, deviceAPI } from 'api'
import ModalForm from 'components/ModalForm'
import AddForward from './AddForward'

import {
  Badge,
  BadgeText,
  Button,
  ButtonText,
  ButtonIcon,
  Box,
  FlatList,
  HStack,
  VStack,
  Text,
  AddIcon,
  ArrowRightIcon,
  TrashIcon,
  EditIcon
} from '@gluestack-ui/themed'

import ListHeader from 'components/List/ListHeader'
import { ListItem } from 'components/List'

const ForwardList = (props) => {
  const [list, setList] = useState([])

  const refreshList = () => {
    firewallAPI.config().then((config) => {
      //setList(config.ForwardingRules)
      let flist = config.ForwardingRules
      deviceAPI
        .list()
        .then((devices) => {
          flist = flist.map((rule) => {
            let deviceDst = Object.values(devices)
              .filter((d) => d.RecentIP == rule.DstIP)
              .pop()

            if (deviceDst) {
              rule.deviceDst = deviceDst
            }

            return rule
          })

          setList(flist)
        })
        .catch((err) => {
          //context.error('deviceAPI.list Error: ' + err)
          setList(flist)
        })
    })
  }

  const deleteListItem = (item) => {
    firewallAPI.deleteForward(item).then((res) => {
      refreshList()
    })
  }

  useEffect(() => {
    refreshList()
  }, [])

  let refModal = useRef(null)
  let editRef = useRef(null)
  const [editing, setEditing] = useState(null)

  const notifyChange = (type) => {
    refModal.current()
    refreshList()
  }

  const notifyEditChange = (type) => {
    editRef.current && editRef.current()
    setEditing(null)
    refreshList()
  }

  return (
    <VStack>
      <ModalForm title="Edit Port Forwarding Rule" modalRef={editRef}>
        <AddForward item={editing} notifyChange={notifyEditChange} />
      </ModalForm>

      <ListHeader
        title="Port Forwarding"
        description="Set rules to forward of incoming traffic"
      >
        <ModalForm
          title="Add Port Forwarding Rule"
          triggerText="Add Forward"
          triggerProps={{
            sx: {
              display: 'flex'
            }
          }}
          modalRef={refModal}
        >
          <AddForward notifyChange={notifyChange} />
        </ModalForm>
      </ListHeader>

      <FlatList
        data={list}
        renderItem={({ item }) => (
          <ListItem>
            <Badge action="muted" variant="outline">
              <BadgeText>{item.Protocol}</BadgeText>
            </Badge>

            <HStack flex={1} space={1} justifyContent="flex-end">
              <Text bold>
                {item.deviceSrc ? item.deviceSrc.Name : item.SrcIP}
              </Text>
              <Text color="$muted500">:</Text>
              <Text>{item.SrcPort}</Text>
            </HStack>

            <ArrowRightIcon color="$muted500" />

            <HStack flex={1} space={1}>
              <Text bold>
                {item.deviceDst &&
                item.deviceDst.Name &&
                item.deviceDst.Name.length > 0
                  ? item.deviceDst.Name
                  : item.DstIP}
              </Text>
              <Text color="$muted500">:</Text>
              <Text>{item.DstPort}</Text>
            </HStack>

            <Text flex={1} color="$muted500" isTruncated>
              {item.Description}
            </Text>

            <Button
              variant="link"
              alignSelf="center"
              onPress={() => {
                setEditing(item)
                editRef.current && editRef.current()
              }}
            >
              <ButtonIcon as={EditIcon} color="$muted600" />
            </Button>

            <Button
              ml="$3"
              alignSelf="center"
              size="sm"
              action="negative"
              variant="link"
              onPress={() => deleteListItem(item)}
            >
              <ButtonIcon as={TrashIcon} color="$red700" />
            </Button>
          </ListItem>
        )}
        keyExtractor={(item) => `${item.Protocol}${item.DstIP}:${item.DstPort}`}
      />

      {!list.length ? (
        <Text
          bg="$backgroundCardLight"
          sx={{ _dark: { bg: '$backgroundCardDark' } }}
          p="$4"
          flexWrap="wrap"
        >
          Forward incoming WAN packets to access a service that runs on the LAN.
        </Text>
      ) : null}

      <Button
        action="primary"
        variant="solid"
        rounded="$none"
        onPress={() => refModal.current()}
      >
        <ButtonText>Add Forward</ButtonText>
        <ButtonIcon as={AddIcon} />
      </Button>
    </VStack>
  )
}

export default ForwardList
